var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-lazy", class: _vm.moduleName }, [
    _c(
      "div",
      {
        staticClass: "loading-box",
        attrs: { role: "status", "aria-label": "loading" },
      },
      [
        _c("div", {
          staticClass: "loading-anim",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "loading-text",
          attrs: { "aria-hidden": "true", label: _vm.$t("common:loading") },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }